/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12 lg12 xl12>
      <header-component class="mb-1 mx-1"></header-component>
    </v-flex>
    <v-flex xs12 sm12 md12 lg12>
      <data-table-component :theme="theme_dark"></data-table-component>
    </v-flex>
    <v-flex xs12 sm12 md12 lg6>
      <stats-component :theme="theme_dark"></stats-component>
    </v-flex>
    <v-flex xs12 sm12 md12 lg6>
      <alert-component :theme="theme_dark"></alert-component>
    </v-flex>
    <v-flex xs12 sm12 md12 lg12>
      <map-component class="mb-6" :theme="theme_dark"></map-component>
    </v-flex>
  </v-layout>
</template>

<script>
import HeaderComponent from '../components/home/thinkHome/HeaderComponent'
import StatsComponent from '../components/home/thinkHome/StatsComponent'
import MapComponent from '../components/home/MapComponent'
import DataTableComponent from '../components/home/thinkHome/DataTableComponent'
import AlertComponent from '../components/home/thinkHome/AlertComponent'
import { mapGettersMixin } from '@/util/mixin/index'

export default {
  mixins: [ mapGettersMixin ],
  components: {
    HeaderComponent,
    StatsComponent,
    MapComponent,
    DataTableComponent,
    AlertComponent
  },
  data () {
    return {
      data: true
    }
  }
}
</script>

<style scoped>
.display-1 {
  color: #2979ff;
}

.v-table .v-datatable__actions {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

canvas {
  padding: 30px;
}

.v-divider--vertical.v-divider--inset {
  height: calc(100% - 30px);
}

.v-toolbar__title:not(:first-child) {
  margin-left: 100px;
}

blink,
.blink {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

/*Theme*/
/* .theme--dark .v-table tbody tr:hover:not(.datatable__expand-row) {
  background-color: #151e3d;
} */
</style>
